import React from 'react';
import {
    Form,
    TextInput,
    useLogin,
    useNotify,
    useTranslate,
} from 'react-admin';
import { Box, Button, CircularProgress, Stack } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { entityResource as ent } from '@src/entityResource';

export const Login = () => {
    const login = useLogin();
    const notify = useNotify();
    const navigate = useNavigate();
    const translate = useTranslate();
    const location = useLocation();
    const [loading, setLoading] = React.useState(false);
    const [userid, setUserid] = React.useState('');
    const [password, setPassword] = React.useState('');

    const handleSubmit = () => {
        setLoading(true);
        login(
            { userid, password },
            location.state ? location.state.nextPathname : '/'
        )
            .then(() => {
                setLoading(false);
                navigate('/');
            })
            .catch((error: Error) => {
                setLoading(false);
                notify(
                    typeof error === 'string'
                        ? error
                        : typeof error === 'undefined' || !error.message
                          ? 'ra.auth.sign_in_error'
                          : error.message,
                    {
                        type: 'error',
                        messageArgs: {
                            _:
                                typeof error === 'string'
                                    ? error
                                    : error && error.message
                                      ? error.message
                                      : undefined,
                        },
                    }
                );
            });
    };

    return (
        <Box>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100vh"
            >
                <Box
                    sx={{
                        width: '320px',
                        padding: '2rem',
                        boxShadow: 3,
                        borderRadius: 2,
                        bgcolor: 'background.paper',
                    }}
                >
                    <Form onSubmit={handleSubmit} noValidate>
                        <Stack direction="column" spacing={2}>
                            <img
                                src="/assets/images/alhan-nobg.png"
                                alt="alhan-nobg.png"
                                style={{
                                    width: '112px',
                                    marginBottom: '1rem',
                                    alignSelf: 'center',
                                }}
                            />
                            <TextInput
                                source="userid"
                                type="text"
                                label={translate('ra.auth.username')}
                                name="userid"
                                autoComplete="userid"
                                value={userid}
                                onChange={e => setUserid(e.target.value)}
                                disabled={loading}
                            />
                            <TextInput
                                source="password"
                                type="password"
                                label={translate('ra.auth.password')}
                                name="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                disabled={loading}
                            />
                            <Button
                                variant="contained"
                                type="submit"
                                color="primary"
                                disabled={loading}
                                sx={{ flex: 1 }}
                            >
                                {loading && (
                                    <CircularProgress size={25} thickness={2} />
                                )}
                                {translate('ra.auth.sign_in')}
                            </Button>
                            <Button
                                onClick={() =>
                                    navigate(ent.PRIVACY_POLICY.NAME)
                                }
                            >
                                Privacy Policy
                            </Button>
                        </Stack>
                    </Form>
                </Box>
            </Box>
        </Box>
    );
};
